/**
 * Turns en_us to en-US. Also en-us to en-US
 * @param str
 * @returns {string|*}
 */
export default (str) => {
  let arr;
  if (str.indexOf('_') !== -1) {
    arr = str.split('_');
  } else if (str.indexOf('-') !== -1) {
    arr = str.split('-');
  } else {
    return str;
  }

  return `${arr[0].toLowerCase()}-${arr[1].toUpperCase()}`;
};
